export const INPUT_MASK_PLACEHOLDER_CHAR = "\u2000";

export const clearInputPlaceholder = (value) => (
  String(value ?? "")
    .split(INPUT_MASK_PLACEHOLDER_CHAR)
    .join("")
);
